module.exports = __webpack_public_path__ + "static/ruey-654d5d7cd9d652b753b8bef9d20863fc.jpg";